<template>
  <div class="row">
    <div class="col-12 col-lg-7 c g">
        <div class="card">
            <div class="card-header">
                <h5>
                    <i class="fa fa-bell"></i>
                   الاخبار التطويرات
                    &nbsp;
                    <button class="btn btn-primary btn-sm" v-b-modal.add style="border-radius: 50%; width: 30px; height: 30px; padding:0px">
                        <i class="fa fa-plus"></i>
                    </button>
                </h5>
            </div>
            <div class="card-footer">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered">
                        <thead>
                            <th>
                                العنوان
                            </th>
                            <th>
                                التاريخ
                            </th>
                            <th>
                                من شاهدها
                            </th>
                            <th>
                                خيارات
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="a in list" :key="a._id">
                                <td>
                                    {{ a.title }}
                                </td>
                                <td>
                                    {{ a.date }}
                                </td>
                                <td>
                                    {{ a.users_seen.length }} من {{ a.users_left.length }}
                                </td>
                                <td>
                                    <button class="btn btn-sm btn-success" @click="current = a" v-b-modal.edit style="border-radius: 0px;padding: 5px">
                                        <i class="fa fa-edit"></i> تعديل
                                    </button>&nbsp;
                                    <button class="btn btn-sm btn-outline-danger" @click="deleteDay(a._id)" style="border-radius: 0px;padding: 5px">
                                        <i class="fa fa-trash"></i> حذف
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="add" title="اضافة اجازة" hide-footer size="lg">
        <div class="form-group">
          <h5 for="">التاريخ</h5>
          <input type="date"
            class="form-control" v-model="create.date">
        </div>
        <div class="form-group">
          <h5 for="">العنوان</h5>
          <input type="text"
            class="form-control" v-model="create.title" placeholder="اكتب هنا...">
        </div>
        <div class="form-group">
          <h5 for="">الوصف المختصر</h5>
          <input type="text"
            class="form-control" v-model="create.short_content" placeholder="اكتب هنا...">
        </div>
        <div class="form-group">
          <h5 for="">الخدمات</h5>
          <select class="form-control" v-model="create.services" multiple style="height: 200px">
            <option v-for="ax in services" :key="ax.code" :value="ax.code">
                {{ ax.title }}
            </option>
          </select>
        </div>
        <ckeditor :editor="editor" v-model="create.content" :config="editorConfig"></ckeditor>
        <div class="col-12 text-center g text-center">
            <button class="btn btn-primary" @click="addnow()">
                اضافة
            </button>
        </div>
    </b-modal>
    <b-modal id="edit" title="اضافة اجازة" hide-footer size="lg">
        <div class="form-group">
          <h5 for="">التاريخ</h5>
          <input type="date"
            class="form-control" v-model="current.date">
        </div>
        <div class="form-group">
          <h5 for="">العنوان</h5>
          <input type="text"
            class="form-control" v-model="current.title" placeholder="اكتب هنا...">
        </div>
        <div class="form-group">
          <h5 for="">الوصف المختصر</h5>
          <input type="text"
            class="form-control" v-model="current.short_content" placeholder="اكتب هنا...">
        </div>
        <div class="form-group">
          <h5 for="">الخدمات</h5>
          <select class="form-control" v-model="current.services" multiple style="height: 200px">
            <option v-for="ax in services" :key="ax.code" :value="ax.code">
                {{ ax.title }}
            </option>
          </select>
        </div>
        <ckeditor :editor="editor" v-model="current.content" :config="editorConfig"></ckeditor>
        <div class="col-12 text-center g text-center">
            <button class="btn btn-primary" @click="editnow()">
                تعديل
            </button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {  VBModal, BModal, BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    BModal
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            list: [],
            editor: ClassicEditor,
            create: {
                date: new Date().toISOString().split("T")[0],
                services: []
            },
            editorConfig: {},
            current: {},
            services: [
            {
                title: "نظام تحضير الطلاب",
                bio: "تحضير الطلاب، المخالفات السلوكية٫ اضافة الغياب الخ...",
                code: "students",
                price: "",
                content: "",
            },
            {
                title: "إرسال الشهادات ومواد الاكمال",
                bio: "ارسال شهادات الفترة ونهاية العام الخ...",
                code: "results",
                content: ""
            },
            {
                title: "الاستبانات والنماذج والكشوف",
                bio: "كشوف المتابعة٬ السجلات المدرسة الخ...",
                code: "mentors",
                content: ""
            },
            {
                title: "رسائل الواتساب التلقائية",
                bio: "ارسال الغياب والتأخر والشهادات واتساب الخ...",
                code: "whatsapp",
                content: ""
            },
            {
                title: "نظام غياب الحصص",
                bio: "أخذ غياب الحصص٫ التقارير الخ...",
                code: "lessons",
                content: ""
            },
            {
                title: "اعداد اللجان",
                bio: "توزيع واعداد اللجان وطباعة الخ...",
                code: "committees",
                content: ""
            },
            {
                title: "نظام المناداة",
                bio: "السماح لولي الأمر بمناداة ابنه أو بنته من داخل التطبيق...",
                code: "calls",
                price: "",
                content: ""
            },
            {
                title: "نظام غياب المعلمين",
                bio: "التقارير٫ التحضير٫ المسائلات الخ...",
                code: "teachers",
                price: "",
                content: ""
            },
            {
                title: "نظام مصروفي",
                bio: "صفحة البائع٫ تقارير الحسابات٫ الخ...",
                code: "masrufi",
                content: ""
            },
            {
                title: "الجدول المدرسي",
                bio: "اعداد الجدول المدرسي لكل فصل ولكل معلم الخ...",
                code: "table",
                content: ""
            },
            {
                title: "التوصيل والنقل المدرسي",
                bio: "يصلح للمدارس وشركات النقل والتوصيل المدرسي...",
                code: "bus",
                content: ""
            }
        ]
        }
    },
    created(){
        this.getList()
    },
    methods: {
        addnow(){
            var g = this;
            $.post(api + '/admin/settings/posts/add', {
                jwt: localStorage.getItem("jwt"),
                title: this.create.title,
                content: this.create.content,
                short_content: this.create.short_content,
                date: this.create.date,
                services: this.create.services
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.getList()
                    $("#add___BV_modal_header_ > button").click()
                }
            }).fail(function(){
            
            })
        },
        editnow(){
            var g = this;
            $.post(api + '/admin/settings/posts/edit', {
                jwt: localStorage.getItem("jwt"),
                id: this.current._id,
                title: this.current.title,
                content: this.current.content,
                short_content: this.current.short_content,
                date: this.current.date,
                services: this.current.services
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.getList()
                    $("#edit___BV_modal_header_ > button").click()
                }
            }).fail(function(){
            
            })
        },
        getList(){
            var g = this;
            $.post(api + '/admin/settings/posts/list', {
                jwt: localStorage.getItem("jwt")
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.list = r.response
                }
            }).fail(function(){
            
            })
        },
        deleteDay(id){
            if(confirm("متأكد من الحذف؟")){
                var g = this;
                $.post(api + '/admin/settings/posts/delete', {
                    jwt: localStorage.getItem("jwt"),
                    id: id
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response)
                    }else{
                        g.getList()
                    }
                }).fail(function(){
                
                })
            }
        }
    }
}
</script>

<style>

</style>